// Weight-class labels for Order.packageType — kept in one place so the
// rider, customer, and admin order views all describe the same enum values
// the same way. Each vehicle has its own realistic 3-tier list (Aug 2026
// update — replaces the old flat doc_parcel/medium/large_heavy list shared
// by every vehicle).
export const PACKAGE_TYPES_BY_VEHICLE = {
  bike: ["bike_under_5kg", "bike_5_10kg", "bike_10_20kg"],
  van: ["van_under_50kg", "van_50_200kg", "van_200_500kg"],
  truck: ["truck_under_1t", "truck_1_3t", "truck_3plus_t"]
};

export const PACKAGE_TYPE_LABELS = {
  bike_under_5kg: "Document / Small Parcel (under 5kg)",
  bike_5_10kg: "Medium Parcel (5–10kg)",
  bike_10_20kg: "Large Parcel (10–20kg)",
  van_under_50kg: "Small Load (under 50kg)",
  van_50_200kg: "Medium Load (50–200kg)",
  van_200_500kg: "Large Load (200–500kg)",
  truck_under_1t: "Light Freight (under 1 ton)",
  truck_1_3t: "Medium Freight (1–3 tons)",
  truck_3plus_t: "Heavy Freight (3+ tons)"
};

export const PACKAGE_CATEGORY_LABELS = {
  food_consumables: "Food / Consumables",
  clothing_accessories: "Clothing / Accessories",
  chemical_liquid: "Chemical / Liquid",
  equipment_tool: "Equipment / Tool",
  home_appliances: "Home Appliances",
  mobile_gadgets: "Mobile Gadgets",
  medical: "Medical",
  essential_supplies: "Essential Supplies",
  others: "Others"
};
